<template>
  <div class="whoz-widget__member-modal" :class="styleClass">
    <div class="flex items-center justify-center h-screen pt-4 px-4 pb-20 text-center
    sm:block sm:p-0">
      <div
        class="fixed inset-0 transition-opacity"
        aria-hidden="true"
        @click="$emit('hideModal')"
      >
        <div class="modal-overlay absolute inset-0 opacity-75" />
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span>

      <div
        class="relative modal-content w-11/12 md:w-1/2 inline-block align-bottom bg-white
        text-left transform transition-all sm:my-8 sm:align-middle sm:w-full max-h-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
        :class="embedOption.square ? 'rounded-none' : 'rounded-lg'"
      >
        <div class="nav-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="34.043"
            viewBox="0 0 20 34.043"
            class="relative md:absolute m-auto top-0 -right-8 md:-right-12 lg:-right-20 bottom-0 cursor-pointer hover_opacity-60 transition-opacity ease-in duration-200"
            @click="$emit('slideModal', 'next')"
          >
            <g
              id="right-arrow_7_"
              data-name="right-arrow (7)"
              transform="translate(-101.478)"
            >
              <g
                id="Group_6449"
                data-name="Group 6449"
                transform="translate(101.478)"
              >
                <path
                  id="Path_6806"
                  data-name="Path 6806"
                  d="M120.935,15.693,105.785.544a1.866,1.866,0,0,0-2.634,0l-1.116,1.115a1.865,1.865,0,0,0,0,2.634l12.721,12.721L102.022,29.75a1.867,1.867,0,0,0,0,2.634l1.116,1.115a1.866,1.866,0,0,0,2.634,0l15.164-15.163a1.879,1.879,0,0,0,0-2.643Z"
                  transform="translate(-101.478)"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="34.043"
            viewBox="0 0 20 34.043"
            class="relative md:absolute m-auto top-0 -left-8 md:-left-12 lg:-left-20 bottom-0 cursor-pointer hover_opacity-60 transition-opacity ease-in duration-200"
            @click="$emit('slideModal', 'prev')"
          >
            <g
              id="right-arrow_7_"
              data-name="right-arrow (7)"
              transform="translate(0 0)"
            >
              <g
                id="Group_6449"
                data-name="Group 6449"
                transform="translate(0 0)"
              >
                <path
                  id="Path_6806"
                  data-name="Path 6806"
                  d="M102.021,15.693,117.171.544a1.866,1.866,0,0,1,2.634,0l1.116,1.115a1.865,1.865,0,0,1,0,2.634L108.2,17.014,120.934,29.75a1.867,1.867,0,0,1,0,2.634L119.818,33.5a1.866,1.866,0,0,1-2.634,0L102.021,18.336a1.879,1.879,0,0,1,0-2.643Z"
                  transform="translate(-101.478)"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="flex flex-col p-6">
          <div class="w-1/2 overflow-hidden mx-auto mt-8">
            <img
              v-if="user.image_url"
              :src="user.image_url"
              alt=""
              class="w-full"
              :class="embedOption.square ? 'rounded-none' : 'rounded-full'"
            >
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="160"
              height="160"
              viewBox="0 0 160 160"
              class="h-full w-full rounded-full"
            >
              <rect
                id="Rectangle_2099"
                data-name="Rectangle 2099"
                width="160"
                height="160"
                fill="#f6f6f6"
              />
              <path
                id="Path_1402"
                data-name="Path 1402"
                d="M67.5,26.643c0,11.471-8.883,20.243-20.5,20.243S26.5,
                38.114,26.5,26.643,35.383,6.4,47,6.4,67.5,15.172,67.5,26.643ZM6,75.225c0-13.5,
                27.333-20.918,41-20.918S88,61.73,88,75.225v6.748H6Z"
                transform="translate(33 32.619)"
                fill="#c7c7c7"
              />
            </svg>
          </div>
          <p class="modal-content__name mt-6 text-xl text-center" :style="{fontSize: embedOption.baseFontSize * 1.25 + 'px'}">
            {{ user.name }}
          </p>
          <p class="modal-content__job-category mt-3 text-base text-center" :style="{fontSize: embedOption.baseFontSize * 0.875 + 'px'}">
            {{ user.job_category }}
          </p>

          <div class="sns-link-container">
            <a
              v-if="user.facebook_url"
              :href="user.facebook_url"
              target="_blank"
              class="sns-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 7.669 15.336"
                class="sns-icon"
              >
                <path
                  id="facebook_4_"
                  data-name="facebook (4)"
                  d="M12.456,2.546h1.4V.108A18.079,18.079,0,0,0,11.816,0c-2.019,0-3.4,1.27-3.4,3.6V5.751H6.187V8.477H8.415v6.859h2.731V8.478h2.137l.339-2.726H11.145V3.874c0-.788.213-1.327,1.311-1.327Z"
                  transform="translate(-6.187)"
                  fill="#0082fd"
                />
              </svg>
            </a>
            <a
              v-if="user.twitter_url"
              :href="user.twitter_url"
              target="_blank"
              class="sns-link"
            >
              <svg
                class="sns-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 14.081 11.444"
              >
                <path
                  id="twitter_2_"
                  data-name="twitter (2)"
                  d="M128.445,144.472q.008.186.008.373a8.164,8.164,0,0,1-8.22,8.22h0a8.178,8.178,0,0,1-4.428-1.3,5.878,5.878,0,0,0,.689.04,5.8,5.8,0,0,0,3.588-1.237,2.892,2.892,0,0,1-2.7-2.007,2.88,2.88,0,0,0,1.3-.05,2.89,2.89,0,0,1-2.318-2.832c0-.013,0-.025,0-.037a2.87,2.87,0,0,0,1.309.361,2.892,2.892,0,0,1-.894-3.857,8.2,8.2,0,0,0,5.955,3.019,2.891,2.891,0,0,1,4.923-2.635,5.8,5.8,0,0,0,1.835-.7,2.9,2.9,0,0,1-1.271,1.6,5.762,5.762,0,0,0,1.659-.455A5.871,5.871,0,0,1,128.445,144.472Zm0,0"
                  transform="translate(-115.805 -141.621)"
                  fill="#0082fd"
                />
              </svg>
            </a>
            <a
              v-if="user.instagram_url"
              :href="user.instagram_url"
              target="_blank"
              class="sns-link"
            >
              <svg
                id="Social_Icons"
                enable-background="new 0 0 128 128"
                version="1.1"
                viewBox="0 0 128 128"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="sns-icon"
              ><g id="_x37__stroke"><g id="Instagram_1_"><rect
                clip-rule="evenodd"
                fill="none"
                fill-rule="evenodd"
                height="128"
                width="128"
              /><radialGradient
                id="Instagram_2_"
                cx="19.1111"
                cy="128.4444"
                gradientUnits="userSpaceOnUse"
                r="163.5519"
              ><stop
                offset="0"
                style="stop-color:#FFB140"
              /><stop
                offset="0.2559"
                style="stop-color:#FF5445"
              /><stop
                offset="0.599"
                style="stop-color:#FC2B82"
              /><stop
                offset="1"
                style="stop-color:#8E40B7"
              /></radialGradient><path
                id="Instagram"
                clip-rule="evenodd"
                d="M105.843,29.837    c0,4.242-3.439,7.68-7.68,7.68c-4.241,0-7.68-3.438-7.68-7.68c0-4.242,3.439-7.68,7.68-7.68    C102.405,22.157,105.843,25.595,105.843,29.837z M64,85.333c-11.782,0-21.333-9.551-21.333-21.333    c0-11.782,9.551-21.333,21.333-21.333c11.782,0,21.333,9.551,21.333,21.333C85.333,75.782,75.782,85.333,64,85.333z M64,31.135    c-18.151,0-32.865,14.714-32.865,32.865c0,18.151,14.714,32.865,32.865,32.865c18.151,0,32.865-14.714,32.865-32.865    C96.865,45.849,82.151,31.135,64,31.135z M64,11.532c17.089,0,19.113,0.065,25.861,0.373c6.24,0.285,9.629,1.327,11.884,2.204    c2.987,1.161,5.119,2.548,7.359,4.788c2.24,2.239,3.627,4.371,4.788,7.359c0.876,2.255,1.919,5.644,2.204,11.884    c0.308,6.749,0.373,8.773,0.373,25.862c0,17.089-0.065,19.113-0.373,25.861c-0.285,6.24-1.327,9.629-2.204,11.884    c-1.161,2.987-2.548,5.119-4.788,7.359c-2.239,2.24-4.371,3.627-7.359,4.788c-2.255,0.876-5.644,1.919-11.884,2.204    c-6.748,0.308-8.772,0.373-25.861,0.373c-17.09,0-19.114-0.065-25.862-0.373c-6.24-0.285-9.629-1.327-11.884-2.204    c-2.987-1.161-5.119-2.548-7.359-4.788c-2.239-2.239-3.627-4.371-4.788-7.359c-0.876-2.255-1.919-5.644-2.204-11.884    c-0.308-6.749-0.373-8.773-0.373-25.861c0-17.089,0.065-19.113,0.373-25.862c0.285-6.24,1.327-9.629,2.204-11.884    c1.161-2.987,2.548-5.119,4.788-7.359c2.239-2.24,4.371-3.627,7.359-4.788c2.255-0.876,5.644-1.919,11.884-2.204    C44.887,11.597,46.911,11.532,64,11.532z M64,0C46.619,0,44.439,0.074,37.613,0.385C30.801,0.696,26.148,1.778,22.078,3.36    c-4.209,1.635-7.778,3.824-11.336,7.382C7.184,14.3,4.995,17.869,3.36,22.078c-1.582,4.071-2.664,8.723-2.975,15.535    C0.074,44.439,0,46.619,0,64c0,17.381,0.074,19.561,0.385,26.387c0.311,6.812,1.393,11.464,2.975,15.535    c1.635,4.209,3.824,7.778,7.382,11.336c3.558,3.558,7.127,5.746,11.336,7.382c4.071,1.582,8.723,2.664,15.535,2.975    C44.439,127.926,46.619,128,64,128c17.381,0,19.561-0.074,26.387-0.385c6.812-0.311,11.464-1.393,15.535-2.975    c4.209-1.636,7.778-3.824,11.336-7.382c3.558-3.558,5.746-7.127,7.382-11.336c1.582-4.071,2.664-8.723,2.975-15.535    C127.926,83.561,128,81.381,128,64c0-17.381-0.074-19.561-0.385-26.387c-0.311-6.812-1.393-11.464-2.975-15.535    c-1.636-4.209-3.824-7.778-7.382-11.336c-3.558-3.558-7.127-5.746-11.336-7.382c-4.071-1.582-8.723-2.664-15.535-2.975    C83.561,0.074,81.381,0,64,0z"
                fill="url(#Instagram_2_)"
                fill-rule="evenodd"
              /></g></g></svg>
            </a>
          </div>

          <p
            v-if="user.introduction"
            class="introduction mt-8 pt-8 text-base border-t overflow-y-auto"
            :style="{fontSize: embedOption.baseFontSize + 'px'}"
            v-html="user.introduction"
            v-linkified:options="{ className: 'outer-link' }"
          />

          <a v-if="user.whoz_url" :href="user.whoz_url" target="_blank" class="whoz-link" :style="{fontSize: embedOption.baseFontSize * 0.875 + 'px'}">
            Whozで詳細を確認する
            <svg id="foreign_1_" class="outer-link-icon" data-name="foreign (1)" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
              <g id="Group_5404" data-name="Group 5404" transform="translate(4.364)">
                <g id="Group_5403" data-name="Group 5403">
                  <path id="Path_6730" data-name="Path 6730" d="M193.273,0H188.91a.545.545,0,1,0,0,1.091h3.047l-5.614,5.614a.545.545,0,1,0,.771.771l5.614-5.614V4.909a.545.545,0,1,0,1.091,0V.545A.545.545,0,0,0,193.273,0Z" transform="translate(-186.182)" fill="#0082fd"/>
                </g>
              </g>
              <g id="Group_5406" data-name="Group 5406" transform="translate(0 2.182)">
                <g id="Group_5405" data-name="Group 5405">
                  <path id="Path_6731" data-name="Path 6731" d="M9.273,96.364a.545.545,0,0,0-.545.545v4.909H1.091V94.182H6a.545.545,0,1,0,0-1.091H.545A.545.545,0,0,0,0,93.636v8.727a.545.545,0,0,0,.545.545H9.273a.545.545,0,0,0,.545-.545V96.909A.546.546,0,0,0,9.273,96.364Z" transform="translate(0 -93.091)" fill="#0082fd"/>
                </g>
              </g>
            </svg>

          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamMemberModal',
  components: {
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    styleClass: {
      type: String,
      default: '',
    },
    initialSlide: {
      type: Number,
      default: 0,
    },
    embedOption: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tw: this.user.twitter_url,
      fb: this.user.facebook_url,
      ig: this.user.instagram_url,
    };
  },

  created() {
    window.addEventListener('keyup', this.slideModal);
  },
  destroyed() {
    window.removeEventListener('keyup', this.slideModal);
  },
  methods: {
    slideModal(e) {
      const { keyCode } = e;
      switch (keyCode) {
        case 39:
          this.$emit('slideModal', 'next');
          break;
        case 37:
          this.$emit('slideModal', 'prev');
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss">
.whoz-widget__member-modal {
  @apply fixed inset-0 overflow-y-auto;
  z-index: 9999;
}
.modal-overlay {
  .dark & {
    @apply bg-gray-700;
  }
  .light & {
    @apply bg-gray-400;
  }
}
.modal-content {
  max-width: 540px;
  max-height: calc(100vh - 4rem);
  .dark & {
    @apply bg-gray-900;
  }
  .light & {
    @apply bg-white;
  }
  > div {
    max-height: 90vh;
  }
  &__name {
    line-height: 1.5
  }
  &__job-category {
    line-height: 1
  }
}
@media (min-width: 640px) {
  .modal-content {
    max-width: 448px;
  }
}
.introduction {
  word-break: break-word;
  white-space: pre-line;
  max-height: 35vh;
  line-height: 1.5;
}
.whoz-link {
  @apply inline-flex items-center self-end hover:opacity-60 mt-8 text-sm font-bold text-sm;
  color: #0082FD;
  .outer-link-icon {
    display: inline-block;
    color: #0082FD;
    margin-left: .25rem;
  }
}
.outer-link {
  @apply hover:opacity-60 italic;
  color: #0082FD;
}
.sns-link-container {
  @apply flex items-center justify-between space-x-6 mx-auto mt-6;
  .sns-link {
    @apply transition duration-300 ease-in-out hover:opacity-60;
  }
  .sns-icon {
    height: 1.5rem;
  }
}

.nav-btn {
  position: absolute;
  width: 100%;
  bottom: -4rem;
  display: flex;
  flex-direction: row-reverse;
  margin: 0 auto;
  height: auto;
  @screen md {
    position: initial;
  }
}
</style>
